import { Amplify } from 'aws-amplify';
import {
  signIn as amplifySignIn,
  signUp as amplifySignUp,
  signOut as amplifySignOut,
  confirmSignUp as amplifyConfirmSignUp,
  confirmSignIn as amplifyConfirmSignIn,
  getCurrentUser as amplifyGetCurrentUser,
  fetchAuthSession as amplifyFetchAuthSession,
  resetPassword as amplifyResetPassword,
  confirmResetPassword as amplifyConfirmResetPassword,
} from 'aws-amplify/auth';

const isLocalStack = process.env.REACT_APP_ENVIRONMENT === 'localstack';

// Configure Amplify once, in the same module that exports auth functions.
// This guarantees the auth functions share the same singleton config.
if (!isLocalStack) {
  const userPoolId = window.REACT_APP_CONFIG?.USER_POOL_ID || process.env.REACT_APP_USER_POOL_ID;
  const userPoolClientId = window.REACT_APP_CONFIG?.USER_POOL_CLIENT_ID || process.env.REACT_APP_USER_POOL_CLIENT_ID;

  if (!userPoolId || !userPoolClientId) {
    throw new Error('Missing required Cognito configuration: USER_POOL_ID and USER_POOL_CLIENT_ID must be defined');
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
      }
    }
  });
}

export {
  amplifySignIn,
  amplifySignUp,
  amplifySignOut,
  amplifyConfirmSignUp,
  amplifyConfirmSignIn,
  amplifyGetCurrentUser,
  amplifyFetchAuthSession,
  amplifyResetPassword,
  amplifyConfirmResetPassword,
  isLocalStack,
};
